export { IndicatorsSidenavComponent } from './lib/indicators-sidenav/indicators-sidenav.component';
export * from './lib/indicators-table.module';
